var map = {
	"./new.png": 501,
	"./คืนยอดเทิร์น1ทุกวัน.png": 502,
	"./คืนยอดเทิร์นเพื่อน1ทุกวัน.png": 503,
	"./ฝากสะสมลูกค้าสล็อต.png": 504,
	"./วันเกิดคืนยอดเทิร์น2เท่า.png": 505,
	"./โปรบอลเสต็ป.png": 506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 291;